var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.728 0.274899C13.0907 0.64143 13.0907 1.2357 12.728 1.60223L1.58517 12.865C1.22254 13.2315 0.634602 13.2315 0.271972 12.865C-0.0906574 12.4985 -0.0906574 11.9042 0.271972 11.5377L11.4148 0.274899C11.7775 -0.0916329 12.3654 -0.0916329 12.728 0.274899Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.271972 0.274899C0.634602 -0.0916329 1.22254 -0.0916329 1.58517 0.274899L12.728 11.5377C13.0907 11.9042 13.0907 12.4985 12.728 12.865C12.3654 13.2315 11.7775 13.2315 11.4148 12.865L0.271972 1.60223C-0.0906574 1.2357 -0.0906574 0.64143 0.271972 0.274899Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.114df49bdf20762d4889cdb502cdacf4.svg";
export { ForwardRef as ReactComponent };